import { render, staticRenderFns } from "./color-alpha-slider.vue?vue&type=template&id=5c5dadab"
import script from "./color-alpha-slider.vue?vue&type=script&lang=js"
export * from "./color-alpha-slider.vue?vue&type=script&lang=js"
import style0 from "./color-alpha-slider.vue?vue&type=style&index=0&id=5c5dadab&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports